import {useState} from 'react';
import {CustomInputBox, CountrySelect, Button, StateSelect, FormValidator, Alert} from 'utils';
import {RegistrationTitle} from './RegistrationTitle';
import {businessRegistrationSteps} from '../data';
import {useBusinessRegistration} from './RegistrationContent';
import {fetchValues, getError} from 'utils/helpers';
import {useRegisterBusiness} from 'hooks';

const defaultValues = {
    proprietor_state: '',
    proprietor_city: '',
    proprietor_street_number: '',
    proprietor_street_name: '',
    proprietor_postcode: '',
    proprietor_lga: '',
};

export const RegistrationPersonalAddress = () => {
    const {setCurrentStep, result, handleStep} = useBusinessRegistration();
    const [formValues, setFormValues] = useState({
        ...defaultValues,
        ...fetchValues(defaultValues, result),
    });
    const [formErrors, setFormErrors] = useState({});
    const [errorMsg, setErrorMsg] = useState();

    const {mutate, isLoading} = useRegisterBusiness({
        onMutate: () => setErrorMsg(),
        onSuccess: ({data, status}) => {
            if (
                (status === 200 || status === 201) &&
                (data?.status_code === 200 || data?.status_code === 201)
            ) {
                handleStep({
                    step: businessRegistrationSteps.BUSINESS_INFORMATION.step,
                    data: {
                        ...formValues,
                        completed_step: Math.max(
                            result?.completed_step || 0,
                            parseInt(data?.data?.completed_step)
                        ),
                        personal_address_result: data?.data,
                    },
                });
            } else setErrorMsg(data?.message);
        },
        onError: error => setErrorMsg(getError(error)),
    });

    const handleSelect = (name, value) => {
        setFormValues(prev => ({...prev, [name]: value}));
        setFormErrors(prev => ({...prev, [name]: ''}));
    };

    const handleChange = ({target: {name, value}}) => handleSelect(name, value);

    const goBack = () => setCurrentStep(businessRegistrationSteps.PERSONAL_INFORMATION.step);

    const handleSubmit = e => {
        e.preventDefault();

        const payload = {...formValues};

        const {isValid, formErrors} = FormValidator(payload);

        if (!isValid) return setFormErrors(formErrors);

        const data = {
            ...payload,
            step: '3',
            proprietor_country: 'Nigeria',
            request_id: result?.request_id,
            proprietor_state: payload?.proprietor_state?.label,
        };

        if ((result?.completed_step || 0) >= 3) {
            data.backStep = '3';
            delete data?.step;
        }

        mutate(data);
    };

    return (
        <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <RegistrationTitle
                title="Address"
                subtitle="We never share this information for marketing purposes. Don't have an office? It's fine to use a home address."
            />
            {errorMsg && (
                <div className="pb-4">
                    <Alert message={errorMsg} onClose={() => setErrorMsg()} />
                </div>
            )}
            <div className="overflow-auto" style={{maxHeight: '300px'}}>
                <div className="row mt-4">
                    <div className="col-12">
                        <CountrySelect
                            label="Country"
                            placeholder="Select Country"
                            name="country"
                            value={{label: 'Nigeria'}}
                            disabled
                        />
                    </div>
                    <div className="col-12">
                        <StateSelect
                            countryCode="NG"
                            label="State"
                            placeholder="State"
                            name="proprietor_state"
                            onChange={value => handleSelect('proprietor_state', value)}
                            value={formValues?.proprietor_state}
                            error={formErrors?.proprietor_state}
                        />
                    </div>
                    <div className="col-lg-6 col-12">
                        <CustomInputBox
                            label="Street Number"
                            name="proprietor_street_number"
                            onChange={handleChange}
                            placeholder="Enter Street Number"
                            value={formValues?.proprietor_street_number}
                            error={formErrors.proprietor_street_number}
                        />
                    </div>
                    <div className="col-lg-6 col-12">
                        <CustomInputBox
                            label="Street Name"
                            name="proprietor_street_name"
                            onChange={handleChange}
                            placeholder="Enter Street Name"
                            value={formValues?.proprietor_street_name}
                            error={formErrors.proprietor_street_name}
                        />
                    </div>
                    <div className="col-12">
                        <CustomInputBox
                            label="City"
                            name="proprietor_city"
                            onChange={handleChange}
                            placeholder="Enter City"
                            value={formValues?.proprietor_city}
                            error={formErrors.proprietor_city}
                        />
                    </div>
                    <div className="col-12">
                        <CustomInputBox
                            label="Local Government Area (LGA)"
                            name="proprietor_lga"
                            onChange={handleChange}
                            placeholder="Enter LGA"
                            value={formValues?.proprietor_lga}
                            error={formErrors.proprietor_lga}
                        />
                    </div>
                    <div className="col-12">
                        <CustomInputBox
                            label="Postcode"
                            name="proprietor_postcode"
                            onChange={handleChange}
                            placeholder="Enter Postcode"
                            value={formValues?.proprietor_postcode}
                            error={formErrors.proprietor_postcode}
                        />
                    </div>
                </div>
            </div>
            <div className="d-flex gap-3 mt-5">
                <Button
                    cls="btn w-100 btn-lg btn--gray"
                    name="Back"
                    handleClick={goBack}
                    disabled={isLoading}
                />
                <Button cls="btn w-100 btn-lg" type="submit" name="Proceed" disabled={isLoading} />
            </div>
        </form>
    );
};
